export const TEXT_SHADOW = "text-shadow: 2px 4px 2px #0000001A;"
export const BOX_SHADOW = "box-shadow: 0px 2px 10px #0000001A;"
export const MODAL_BOX_SHADOW = "box-shadow: 0px 2px 20px #00000066;"
